import React from "react";
import { graphql } from "gatsby";
import classNames from "classnames";
import Button from "../atoms/button";

const IntroModule = ({
  pretitle,
  title,
  subtitle,
  description,
  cta,
  isFirst,
  className,
  isCartModal,
}) => {
  return (
    <>
      {title && (
        <div className={classNames("section-titles", className)}>
          {pretitle && <div className="pretitle-lp">{pretitle}</div>}
          <div className="section-title">
            <div
              className={classNames(
                "section-title__content",
                isCartModal && "section-title__content--cart-modal"
              )}
            >
              <div className="section-title__main">
                {title &&
                  (isFirst ? (
                    <h1
                      className={classNames(
                        "section-title__main-text",
                        isCartModal && "section-title__main-text--cart-modal"
                      )}
                    >
                      {title}
                    </h1>
                  ) : (
                    <h2
                      className={classNames(
                        "section-title__main-text",
                        isCartModal && "section-title__main-text--cart-modal"
                      )}
                    >
                      {title}
                    </h2>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {subtitle && <div className="subtitle-lp">{subtitle}</div>}
      {description && (
        <div className="description-lp" dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
      {(cta?.[0].label || cta?.[0].link) && cta.length > 0 && (
        <div className="editorial-slider__buttons section-title-cta">
          {cta.map((button, i) =>
            button.label && button.link ? (
              <Button
                data={button}
                className={classNames(
                  // "default secondary",
                  // (button.color?.[0] === "white" || i > 1) && "alternate",
                  {
                    "primary blue": i % 2 === 0,
                    "secondary white": i % 2 !== 0,
                    "open-modal video": button.type?.[0] === "video",
                  }
                )}
                key={i}
              />
            ) : null
          )}
        </div>
      )}
    </>
  );
};

export default IntroModule;
export const fragment = graphql`
  fragment IntroModuleFragment on LiferayIntroModule {
    pretitle
    title
    subtitle
    description
    cta {
      color
      label
      link
      target
      type
    }
  }
`;
